import { ServiceCallItem, ServiceCallMessages } from "./service-calls-response";

const row = (
    {
        notificationType,
        fullMachineName,
        status,
        sisCaseId,
        createdByUser,
        detailLink,
        creationDate,
        description,
        unreadChatMessages,
    }: ServiceCallItem,
    messages: ServiceCallMessages
): string => {
    if (unreadChatMessages > 0) {
        status.text = messages.unreadChatMessagesText;
    }

    return `
    <tr>
        <td>
           ${fullMachineName ?? "-"}
        </td>
        <td>
            ${renderProductionStatusLabel(
                status.text,
                status.type,
                unreadChatMessages
            )}
        </td>
        <td style="max-width: 400px" class="ux-table--no-wrap">
            <span class="ux-u-text-bold ux-table__copy-with-headline">${notificationType}</span>
            ${description || ""}
        </td>
        <td>${sisCaseId}</td>
        <td>${createdByUser}</td>
        <td>${creationDate}</td>
        <td>
            <ux-button size="icon" icon="chevron-right" href="${detailLink}"></ux-button>
        </td>
    </tr>
    `;
};

const renderProductionStatusLabel = (
    labelText: string,
    type: string,
    /** @deprecated should not be necessary when the "new message" status is handled on the BE */
    messageCount: number | null
) => {
    return `<ux-w-service-calls-status type="${type}" message-count="${messageCount}">${labelText}</ux-w-service-calls-status>`;
};

export default row;
